import {createContext, useState} from "react";

export const SmsLogContext = createContext({})

export const Provider = (props) => {
    const {children} = props;

    const [smsLog, setSmsLog] = useState(null);
    const [smsLogs, setSmsLogs] = useState([]);
    const [smsLogDialog, setSmsLogDialog] = useState(false);

    // Make the context object:
    const smsLogContext = {
        smsLog,
        setSmsLog,
        smsLogs,
        setSmsLogs,
        smsLogDialog,
        setSmsLogDialog,
    };

    // pass the value in provider and return
    return <SmsLogContext.Provider value={smsLogContext}>{children}</SmsLogContext.Provider>;
}

export const {Consumer} = SmsLogContext;
